module.exports = __webpack_public_path__ + "img/chain_logo_black.a5051b98.png";